import { Box, Button, Container, styled } from "@mui/material";

export const StyledBox = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  position: "relative",
  backgroundRepeat: "repeat",
  "&::before": {
    backgroundImage: "url('/arkaplan.png')",
    content: '""',
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backgroundPosition: "center",
    filter: "blur(5px)",
    opacity: 0.7,
    zIndex: -1,
  },
}));